import { NgModule, LOCALE_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ApplicationRef, OnInit } from '@angular/core';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

//AuthGuard
import { AuthGuard } from './auth.guard'

//Custom routing module
import { appRouting } from './app.routing'

//import { PreBootService } from './Service/preboot.service'; //!important - Do Not move

//Angular modules
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { CommonModule, DatePipe, CurrencyPipe, Location } from "@angular/common";

//Ngx-toastr
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

//Installed modules
import { OrderModule } from 'ngx-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxLoadingModule } from 'ngx-loading';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CKEditorModule } from 'ng2-ckeditor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';

//Components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { BusyComponent } from './busy/busy.component';
import { MenuComponent } from './menu/menu.component';

//Shared Components

//Message pop-up components
import { ConfirmComponent } from './popup/confirm.component';
import { AlertComponent } from './popup/alert.component';
import { PromptComponent } from './popup/prompt.component';
import { ParentDialogComponent } from './popup/parent-dialog.component';
import { ErrorComponent } from './popup/error.component';
import { CommentComponent } from './popup/comment.component';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';

//Service
import { GlobalsService } from './services/globals.service';
import { NavigationService } from './services/navigation.service';
import { AuthenticationService } from './services/authentication.service';
import { MenuService } from './services/menu.service';
import { PopupService } from './services/shared/popup.service';
import { VehicleMakeService } from './services/vehicle-make.service';
import { VehicleTypeService } from './services/vehicle-type.service';
import {FreightTypeService} from './services/freight-type.service';
import { StatusService } from './services/status.service';
import { UtilityServiceService } from './services/utility-service.service';
import { PermitTypeService } from './services/permit-type.service';
import { CarrierTypeService } from './services/carrier-type.service';
import { DocumentsServiceService } from './services/documents-service.service';
import { DocumenttypeService } from './services/documenttype.service';
import { CarrierTypeDocumentService } from './services/carrier-type-document.service';
import { ApplicationService } from './services/application.service';
import { VehicleService } from './services/vehicle.service';
import { PermitService } from './services/permit.service';
import { CarrierworkflowService } from './services/carrierworkflow.service';
import { WorkflowdashboardService } from './services/workflowdashboard.service';
import { RunMaintenanceTasksService } from './services/run-maintenance-tasks.service';
import { RunCorrespondenceTasksService } from './services/run-correspondence-tasks.service';
import { CarrierAccountService } from './services/carrier-account.service';
import { GooglePlacesSearchService } from './services/google-places-search.service';
import { PayGateService } from './services/paygate.service';

//Custom routing module

//Custom pipes
import { CurrencyFormat } from './pipes/currencyFormat.pipe';
import { NoSanitizePipe } from './pipes/noSanitize.pipe';
import { VehicleTypeComponent } from './maintain/vehicle-type/vehicle-type.component';
import { ListVehicleTypeComponent } from './maintain/list-vehicle-type/list-vehicle-type.component';
import { ListVehicleMakeComponent } from './maintain/list-vehicle-make/list-vehicle-make.component';
import { VehicleMakeComponent } from './maintain/vehicle-make/vehicle-make.component';
import { PermitTypeComponent } from './maintain/permit-type/permit-type.component';
import { ListPermitTypeComponent } from './maintain/list-permit-type/list-permit-type.component';
import { ListStatusComponent } from './maintain/list-status/list-status.component';
import { StatusComponent } from './maintain/status/status.component';
import { ListCarrierTypeComponent } from './maintain/list-carrier-type/list-carrier-type.component';
import { CarrierTypeComponent } from './maintain/carrier-type/carrier-type.component';
import { AuthWebService } from './services/authweb.service';
import { LoginComponent } from './login/login.component';
import { StorageService } from './services/storage.service';
import { HttpClientModule } from '@angular/common/http';
import { RegisterComponent } from './register/register.component';
import { AmmenduserComponent } from './ammenduser/ammenduser.component';
import { CompanydetailsComponent } from './companydetails/companydetails.component';
import { CaLandingPageComponent } from './ca-landing-page/ca-landing-page.component';
import { EqualvalidatorDirective } from './validators/equalvalidator.directive';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetComponent } from './reset/reset.component';
import { UsernameComponent } from './forgot/username/username.component';
import { UploaddocumentComponent } from './uploaddocument/uploaddocument.component';
import { ConfirmpasswordchangeComponent } from './reset/confirmpasswordchange/confirmpasswordchange.component';
import { ListDocumentTypeComponent } from './maintain/list-document-type/list-document-type.component';
import { DocumentTypeComponent } from './maintain/document-type/document-type.component';
import { CarrierService } from './services/carrier.service';
import { ManagementComponent } from './carrier-account/management/management.component';
import { CaContactPageComponent } from './ca-contact-page/ca-contact-page.component';
import { ComplianceLegalComponent } from './carrier-account/compliance-legal/compliance-legal.component';
import { TransportAssocService } from './services/transport-assoc.service';
import { PermitApplicationComponent } from './permits/permit-application/permit-application.component';
import { NewPermitApplicationComponent } from './permits/permit-application/new-permit-application/new-permit-application.component';
import { AppPermitTypeComponent } from './permits/permit-application/shared/app-permit-type/app-permit-type.component';
import { AppVehicleComponent } from './permits/permit-application/shared/app-vehicle/app-vehicle.component';
import { AppRouteComponent } from './permits/permit-application/shared/app-route/app-route.component';
import { AppMotivationComponent } from './permits/permit-application/shared/app-motivation/app-motivation.component';
import { AppUploadsComponent } from './permits/permit-application/shared/app-uploads/app-uploads.component';
import { CountryService } from './services/country.service';
import { SubmissionComponent } from './carrier-account/submission/submission.component';
import { ListCarrierTypeDocumentComponent } from './maintain/list-carrier-type-document/list-carrier-type-document.component';
import { CarrierTypeDocumentComponent } from './maintain/carrier-type-document/carrier-type-document.component';
import { ViewPermitApplicationComponent } from './permits/permit-application/view-permit-application/view-permit-application.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { TransportAssociationComponent } from './maintain/transport-association/transport-association.component';
import { TransportAssociationListComponent } from './maintain/list-transport-association/transport-association-list.component';
import { WorkflowdashboardComponent } from './workflow/workflowdashboard/workflowdashboard.component';
import { PermitTypeDocumentComponent } from './maintain/permit-type-document/permit-type-document.component';
import { ListPermitTypeDocumentComponent } from './maintain/list-permit-type-document/list-permit-type-document.component';
import { ConfirmationComponent } from './permits/permit-application/shared/confirmation/confirmation.component';
import { ErrorsComponent } from './shared/errors/errors.component';
import { FooterBtnComponent } from './shared/footer-btn/footer-btn.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { ApprovalManagerComponent } from './approval-manager/approval-manager.component';
import { PermitViewerComponent } from './application-approval/permit-viewer/permit-viewer.component';
import { CarrierViewerComponent } from './application-approval/carrier-viewer/carrier-viewer.component';
import { MotivationViewerComponent } from './application-approval/shared/motivation-viewer/motivation-viewer.component';
import { PermitTypeViewerComponent } from './application-approval/shared/permit-type-viewer/permit-type-viewer.component';
import { RouteViewerComponent } from './application-approval/shared/route-viewer/route-viewer.component';
import { UploadsViewerComponent } from './application-approval/shared/uploads-viewer/uploads-viewer.component';
import { VehicleViewerComponent } from './application-approval/shared/vehicle-viewer/vehicle-viewer.component';
import { ConfirmationViewerComponent } from './application-approval/shared/confirmation-viewer/confirmation-viewer.component';
import { PermitApprovalListComponent } from './approval-manager/permit-approval-list/permit-approval-list.component';
import { PermitCorrespondenceComponent } from './approval-manager/permit-correspondence/permit-correspondence.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ManagerComponent } from './carrier-account/approve/manager/manager.component';
import { ListAccountsComponent } from './carrier-account/approve/list-accounts/list-accounts.component';
import { CarriercorrespondenceComponent } from './carrier-account/approve/carriercorrespondence/carriercorrespondence.component';
import { AddRouteComponent } from './maintain/route-management/add-route/add-route.component';
import { PrintingComponent } from './approval-manager/printing/printing.component';
import { ManageCountriesComponent } from './maintain/manage-countries/manage-countries.component';
import { AddNewPlaceComponent } from './maintain/add-new-place/add-new-place.component';
import { PlaceService } from './services/place.service'
import { ManageCountryPlacesComponent } from './maintain/manage-country-places/manage-country-places.component';
import { ListPermitTypeVehicleComponent } from './maintain/list-permit-type-vehicle/list-permit-type-vehicle.component';
import { ListRouteComponent } from './maintain/route-management/list-route/list-route/list-route.component';
import { PermitTypeVehicleService } from './services/permit-type-vehicle.service';
import { CorspdcService } from './services/corspdc.service';
import { CorspdcComponent } from './corspdc/corspdc.component';
import { PermitListApplicationComponent } from './permit-list-application/permit-list-application.component';
import { YesNoComponent } from './popup/yesno.component';
import { PermitCertificateReturnComponent } from './maintain/permit-certificate-return/permit-certificate-return.component';
import { RunMaintenanceTasksComponent } from './maintain/run-maintenance-tasks/run-maintenance-tasks.component';
import { BatchComponent } from './corspdc/batch/batch.component';
import { StatementComponent } from './carrier-account/statement/statement.component';
import { InvoiceComponent } from './carrier-account/statement/invoice/invoice.component';
import { RunCorrespondenceTasksComponent } from './maintain/run-correspondence-tasks/run-correspondence-tasks.component';
import { UnderConstructionComponent } from './permits/permit-application/shared/under-construction/under-construction.component';
import { DemographicsComponent } from './carrier-account/demographics/demographics.component';
import { ConsultantComponent } from './consultant/consultant.component';
import { CustomToastComponent } from './popup/custom-toast/custom-toast.component';
import { RenewPermitComponent } from './permits/permit-application/renew-permit/renew-permit.component';
import { NgxIntlTelInputModule } from './shared/projects/ngx-intl-tel-input/src/lib/ngx-intl-tel-input.module';
import { AssignRolePopupComponent } from './consultant/popups/assign-role-popup.component';
import { LinkCarrierAccountComponent } from './carrier-account/link-carrier-account/link-carrier-account.component';
import { DeLinkCarrierAccountComponent } from './carrier-account/delink-carrier-account/delink-carrier-account.component';
import { EnterOtpPopupComponent } from './carrier-account/link-carrier-account/enter-otp-popup/enter-otp-popup.component';
import { EnterConfirmationPopupComponent } from './carrier-account/delink-carrier-account/enter-confirmation-popup/enter-confirmation-popup.component';
import { TimetableService } from './services/timetable.service';
import { ManageComponent } from './permits/permit-application/timetable/manage/manage.component';
import { ExtractViewsComponent } from './extract-views/extract-views/extract-views.component';
import { RunExtractsComponent } from './extract-views/extract-views/run-extracts/run-extracts.component';
import { AddDataExtractComponent } from './extract-views/extract-views/add-data-extract/add-data-extract.component';
import { TimetableComponent } from './permits/permit-application/timetable/timetable.component';
import { CustomTimeZonePipe } from './pipes/custom-time-zone.pipe';
import { FooterComponent } from './carrier-account/statement/footer/footer.component';
import { CarriertransactionService } from './services/carriertransaction.service';
import { FooterStatmentComponent } from './carrier-account/statement/footer-statment/footer-statment.component';
import { IdleManagerService } from './services/idle-manager.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'angular2-moment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ViewPermitComponent } from './maintain/view-permit/view-permit.component';
import { ManageVehiclesComponent } from './maintain/manage-vehicles/manage-vehicles.component';
import { VehicleEntryService } from './services/vehicle-entry.service';
import { VehicleEntryCarrierService } from 'app/services/vehicle-entry-carrier.service';
import { TableModule } from 'primeng/table';
import { ExternalVehiclesComponent } from './maintain/external-vehicles/external-vehicles.component';
import { CarrierDetailsComponent } from './permits/permit-application/shared/carrier-details/carrier-details.component';
import { CalendarViewerComponent } from './shared/calendar-viewer/calendar-viewer.component';
import { TripComponent } from './shared/calendar-viewer/trip/trip.component';
import { FileDropModule } from 'ngx-file-drop';
import { ListFreightTypeComponent } from './maintain/list-freight-type/list-freight-type.component';
import { EditFreightTypeComponent } from './maintain/edit-freight-type/edit-freight-type.component';
import { CarrierComplianceListComponent } from './compliance/carrier-compliance-list/carrier-compliance-list.component';
import { CompliancereturnsService } from './services/compliancereturns.service';
import { SessionService } from './services/session.service';
import { CalendarService } from './services/calendar.service';
import { SupportComponent } from './support/support.component';
import { ComplianceApplicationComponent } from './compliance/compliance-application/compliance-application.component';
import { ComplianceReturnListComponent } from './compliance/compliance-return-list/compliance-return-list.component';
import { ComplianceDetailsComponent } from './compliance/compliance-details/compliance-details.component';
import { CConfirmationComponent } from './compliance/confirmation/c-confirmation.component';

//PAYGATE
import { AccountDepositComponent } from './PayGate/accountDeposit.component';
import {PaymentCompleteComponent} from './PayGate/PaymentComplete/paymentComplete.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { BootstrapModalModule, DialogService } from 'ng2-bootstrap-modal';
import { ConfirmDialogModule } from './services/shared/confirm-dialog/confirm-dialog.module';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import {MsalModule, MsalService, MSAL_INSTANCE} from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

//import { HttpInterceptor } from '@angular/common/http';

//Custom pre-boot service
// export function prebootServiceFactory(prebootService: PreBootService): Function {
//     return () => prebootService.load();
// }

import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialAuthServiceConfig, SocialLoginModule } from 'angular12-social-login'; 
import { SocialUser } from 'angular12-social-login'; 
import { environment } from 'environments/environment';
import { FacebookpolicyComponent } from './facebookpolicy/facebookpolicy.component';
import { ListSessionComponent } from './maintain/list-session/list-session.component';
import { AddScannerComponent } from './maintain/add-scanner/add-scanner.component';
import { ListScannerComponent } from './maintain/list-scanner/list-scanner.component';
import { CredentialResponse, PromptMomentNotification } from 'google-one-tap';

// let gapiClientConfig: NgGapiClientConfig = {
//   client_id: "42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com",
//   discoveryDocs: ["https://analyticsreporting.googleapis.com/$discovery/rest?version=v4"],
//   ux_mode: "redirect",
//   redirect_uri: "https://ng-gapi-example.stackblitz.io/redirect",
//   scope: [
//       "https://www.googleapis.com/auth/userinfo.profile"
//   ].join(" ")
// };

const fbLoginOptions = {
    scope: 'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
    return_scopes: true,
    enable_profile_selector: true
  }; // https://developers.facebook.com/docs/reference/javascript/FB.login/v2.11
  
  const googleLoginOptions = {
    scope: 'profile email',
    plugin_name:'login',
    cookiepolicy: 'single_host_origin'
  }; // https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2clientconfig
  
  const vkLoginOptions = {
    fields: 'photo_max,contacts', // Profile fields to return, see: https://vk.com/dev/objects/user
    version: '5.124', // https://vk.com/dev/versions
  }; // https://vk.com/dev/users.get

export function socialConfigs() {
    const config = [
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('502819838047618', fbLoginOptions),
      },
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(
          '922769349816-o4sujaq5m0gs033ilvneqj8taffa71qs.apps.googleusercontent.com',
          googleLoginOptions
        ),
      },
    ];
    return config;
  }
  export function MSALInstanceFactory():IPublicClientApplication{
    return new PublicClientApplication({
        auth: {
            clientId: 'd6b2061d-8857-41e0-a99d-a3578b390e59',
            redirectUri: environment.azure.redirectUri  
        }
    })
}

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        MenuComponent,
        BusyComponent,
        //Share Components
        //Popup Components
        ConfirmComponent,
        AlertComponent,
        PromptComponent,
        ParentDialogComponent,
        YesNoComponent,
        ErrorComponent,
        CommentComponent,
        //Currency
        CurrencyFormat,
        NoSanitizePipe,
        VehicleTypeComponent,
        ListVehicleTypeComponent,
        ListVehicleMakeComponent,
        VehicleMakeComponent,
        PermitTypeComponent,
        ListPermitTypeComponent,
        ListStatusComponent,
        StatusComponent,
        ListCarrierTypeComponent,
        CConfirmationComponent,
        CarrierTypeComponent,
        LoginComponent,
        RegisterComponent,
        AmmenduserComponent,
        CompanydetailsComponent,
        CaLandingPageComponent,
        EqualvalidatorDirective,
        ForgotComponent,
        ResetComponent,
        UsernameComponent,
        ManagementComponent,
        UploaddocumentComponent,
        ConfirmpasswordchangeComponent,
        ListDocumentTypeComponent,
        DocumentTypeComponent,
        ComplianceLegalComponent,
        SubmissionComponent,
        DocumentTypeComponent,
        ListCarrierTypeDocumentComponent,
        CarrierTypeDocumentComponent,
        //
        ResetComponent,
        UsernameComponent,
        ManagementComponent,
        UploaddocumentComponent,
        ConfirmpasswordchangeComponent,
        CaContactPageComponent,
        PermitApplicationComponent,
        NewPermitApplicationComponent,
        AppPermitTypeComponent,
        AppVehicleComponent,
        AppRouteComponent,
        AppMotivationComponent,
        AppUploadsComponent,
        ViewPermitApplicationComponent,
        SideMenuComponent,
        TransportAssociationComponent,
        TransportAssociationListComponent,
        WorkflowdashboardComponent,
        PermitTypeDocumentComponent,
        ListPermitTypeDocumentComponent,
        ConfirmationComponent,
        ErrorsComponent,
        ActivateAccountComponent,
        ApprovalManagerComponent,
        FooterBtnComponent,
        PermitViewerComponent,
        CarrierViewerComponent,
        MotivationViewerComponent,
        PermitTypeViewerComponent,
        RouteViewerComponent,
        UploadsViewerComponent,
        VehicleViewerComponent,
        ConfirmationViewerComponent,
        PermitApprovalListComponent,
        PermitCorrespondenceComponent,
        ManagerComponent,
        ListAccountsComponent,
        CarriercorrespondenceComponent,
        AddRouteComponent,
        PrintingComponent,
        ManageCountriesComponent,
        AddNewPlaceComponent,
        ListRouteComponent,
        ManageCountriesComponent,
        AddNewPlaceComponent,
        ManageCountryPlacesComponent,
        ListPermitTypeVehicleComponent,
        CorspdcComponent,
        PermitListApplicationComponent,
        PermitCertificateReturnComponent,
        RunCorrespondenceTasksComponent,
        RunMaintenanceTasksComponent,
        UnderConstructionComponent,
        BatchComponent,
        CustomToastComponent,
        StatementComponent,
        InvoiceComponent,
        DemographicsComponent,
        ConsultantComponent,
        InvoiceComponent,
        RenewPermitComponent,
        AssignRolePopupComponent,
        LinkCarrierAccountComponent,
        DeLinkCarrierAccountComponent,
        EnterOtpPopupComponent,
        EnterConfirmationPopupComponent,
        TimetableComponent,
        ManageComponent,
        CustomTimeZonePipe,
        ExtractViewsComponent,
        RunExtractsComponent,
        AddDataExtractComponent,
        FooterComponent,
        FooterStatmentComponent,
        ViewPermitComponent,
        ManageVehiclesComponent,
        ExternalVehiclesComponent,
        CarrierDetailsComponent,
        CalendarViewerComponent,
        TripComponent,
        ListFreightTypeComponent,
        EditFreightTypeComponent,
        CarrierComplianceListComponent,
        ComplianceDetailsComponent,
        ComplianceReturnListComponent,
        ComplianceApplicationComponent,
        SupportComponent,
        //Paygate
        AccountDepositComponent,
        PaymentCompleteComponent,
        FacebookpolicyComponent,
        ListSessionComponent,
        AddScannerComponent,
        ListScannerComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
         TableModule,
        PdfViewerModule,
        PdfJsViewerModule,
        BrowserModule,
        HttpClientModule,
        OrderModule,
        // BootstrapModalModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        NgxLoadingModule.forRoot({}),
        appRouting,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger' // set defaults here
        }),
        CKEditorModule,
        NgbModule,
        RecaptchaModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            disableTimeOut: true,
            tapToDismiss: false,
            positionClass: 'toast-center-center',
            closeButton: true,
            preventDuplicates: true,
            maxOpened: 1
        }),
        NgMultiSelectDropDownModule.forRoot(),
        NgxIntlTelInputModule,
        NgIdleKeepaliveModule.forRoot(),
        MomentModule,
        ModalModule.forRoot(),
        FileDropModule,
        NgxExtendedPdfViewerModule,
        SocialLoginModule,
        MsalModule,
    ],
    providers: [
        AuthGuard,
        // { provide: Http, useClass: ExtendedHttpService },
        // PreBootService,
        // {
        //     provide: APP_INITIALIZER,
        //     useFactory: prebootServiceFactory,
        //     deps: [PreBootService],
        //     multi: true
        // },
        // DialogService,
        DatePipe,
        CurrencyPipe,
        GlobalsService,
        NavigationService,
        NavigationService,
        AuthenticationService,  
        MenuService,
        PopupService,
        StatusService,
        VehicleTypeService,
        FreightTypeService,
        VehicleMakeService,
        UtilityServiceService,
        PermitTypeService,
        CarrierTypeService,
        AuthWebService,
        StorageService,
        CarrierService,
        DocumentsServiceService,
        DocumenttypeService,
        TransportAssocService,
        CountryService,
        PlaceService,
        CarrierTypeDocumentService,
        ApplicationService,
        PayGateService,
        VehicleService,
        PermitService,
        CarrierworkflowService,
        WorkflowdashboardService,
        PermitTypeVehicleService,
        CorspdcService,
        RunMaintenanceTasksService,
        RunCorrespondenceTasksService,
        CarrierAccountService,
        TimetableService,
        CarriertransactionService,
        IdleManagerService,
        GooglePlacesSearchService,
        VehicleEntryService,
        VehicleEntryCarrierService,
        CompliancereturnsService,
        CalendarService,
        SessionService,
        {
            provide: LOCALE_ID,
            useValue: 'en-ZA'
        },   {
            provide: 'SocialAuthServiceConfig',
            useValue: {
              autoLogin: false,
              prompt: "select_account",
              providers: [
                {
                  id: FacebookLoginProvider.PROVIDER_ID,
                  provider: new FacebookLoginProvider('502819838047618'),
                }, {
                  id: GoogleLoginProvider.PROVIDER_ID,
                  provider: new GoogleLoginProvider('922769349816-o4sujaq5m0gs033ilvneqj8taffa71qs.apps.googleusercontent.com', googleLoginOptions),
                },
              ],
              onError: (err) => {
                console.error(err);
              },
            } as SocialAuthServiceConfig,
          },
        {
            provide:MSAL_INSTANCE,
            useFactory:MSALInstanceFactory
        },
        MsalService
    ]
})
export class AppModule implements OnInit {
    user: SocialUser | undefined;
    loggedIn: boolean | undefined;
  
    constructor(private authService: SocialAuthService,applicationRef: ApplicationRef) {
        Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
    }
  
    ngOnInit(): void {
      this.authService.authState.subscribe((user) => {
        this.user = user;
        this.loggedIn = user != null;
      });
    }
//   constructor(applicationRef: ApplicationRef) {
//     //for ng2-bootstrap-modal in angualar 5
//     Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
//   }
}
